import { Box, Text, Path } from '@st/document-rendering'
import { StampAnnotation } from '@st/sdk'
import { memo } from 'react'
import { LinearTransform } from '@st/geom'

export const StampView = memo(StampViewBase)

type VectorGlyph = { path: string; size: number }

const VECTOR_GLYPHS: Record<string, VectorGlyph> = {
  '✓': {
    path: 'M10.5 3.25L4.5 9.25L1.75 6.5L2.75 5.5L4.5 7.25L9.5 2.25L10.5 3.25Z',
    size: 12
  }
}

function StampViewBase({ annotation }: { annotation: StampAnnotation }) {
  const glyphSpec = VECTOR_GLYPHS[annotation.text]

  return (
    <Box
      width={annotation.bounds.width}
      height={annotation.bounds.height}
      backgroundColor={annotation.backgroundColor}
      alignment="center"
      border={
        annotation.border
          ? {
              color: annotation.border.color!,
              width: annotation.border.width,
              radius: annotation.border.radius
            }
          : undefined
      }
    >
      {glyphSpec ? (
        <Path
          d={glyphSpec.path}
          fill={annotation.color}
          transform={LinearTransform.scale(annotation.bounds.width / glyphSpec.size)}
        />
      ) : (
        <Text
          fontFamily={annotation.font.family}
          fontSize={annotation.font.size}
          color={annotation.color}
        >
          {annotation.text}
        </Text>
      )}
    </Box>
  )
}
